export enum ProjectTypeEnum {
   NEW_CONSTRUCTION = "new construction",
   RETROFIT = "retrofit"
}